module.exports = __webpack_public_path__ + "img/Support.5c2ff7d.svg";